import React from 'react';

function featuredImage(props) {
    const { image, imageSize, svg } = props;

    let imgTag = '';

    if (svg) {
        imgTag = (
            <img
                src={image.src[0]}
                alt={image.title.rendered}
                loading="lazy"
            ></img>
        );

        return imgTag;
    }

    let srcset =
        props.srcset && props.srcset[imageSize] ? props.srcset[imageSize] : '';
    if (
        image &&
        image[0].media_details &&
        image[0].media_details.sizes[imageSize]
    ) {
        imgTag = (
            <img
                src={image[0].media_details.sizes[imageSize].source_url}
                srcSet={srcset}
                alt={image[0].title.rendered}
                loading="lazy"
            ></img>
        );
    } else if (image && image[0].media_details) {
        
        let src = image[0].media_details.source_url;

        // console.log(image[0]);

        // if (image[0].media_details.sizes.full) {
        //     src = image[0].media_details.sizes.full.source_url;
        // } else if (image[0].src[0].length) {

        //     src = image[0].src[0];
        // }

        imgTag = (
            <img
                src={src}
                srcSet={srcset}
                alt={image[0].title.rendered}
                loading="lazy"
            ></img>
        );
    }

    return imgTag;
}

export default featuredImage;
